import styled, { CSSObject } from 'styled-components';

interface ListItemStyledProps {
  alignItems: string;
  bold: boolean;
  sx?: CSSObject;
}

const ListItemStyled = styled.li<ListItemStyledProps>(
  ({ theme, bold, alignItems, sx }) => ({
    position: 'relative',
    marginBottom: theme.space[2],
    display: 'flex',
    alignItems,
    color: theme.color.wfBlack,
    fontSize: theme.font.size.default,
    fontWeight: bold ? theme.font.weight.bold : theme.font.weight.regular,
    ...sx,
  }),
);

export { ListItemStyled };
